"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocalStorageItem = getLocalStorageItem;
exports.removeLocalStorageItem = removeLocalStorageItem;
exports.setLocalStorageItem = setLocalStorageItem;
function setLocalStorageItem(key, value) {
  window.localStorage[key] = value;
}
function getLocalStorageItem(itemName) {
  return window.localStorage.getItem(itemName);
}
function removeLocalStorageItem(itemName) {
  window.localStorage.removeItem(itemName);
}